// extracted by mini-css-extract-plugin
export default {"titleWrapper":"styles_titleWrapper__r68jk","descriptionWrapper":"styles_descriptionWrapper__TE3OW","infoWrapper":"styles_infoWrapper__s-gFD"};